// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDoreGuDXN56QCZMpMD5Cewmtw-UzUEE5g",
    authDomain: "maarava-9a16e.firebaseapp.com",
    projectId: "maarava-9a16e",
    storageBucket: "maarava-9a16e.appspot.com",
    messagingSenderId: "1088219265761",
    appId: "1:1088219265761:web:7b84ae97ec0d3ad25255a0",
    measurementId: "G-J8V7LDVERY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export function createAnalyticsEvent({eventName, eventParams}){
    logEvent(analytics, eventName, eventParams);
}